export default __webpack_public_path__ + "static/media/verified-icon.815dc639.svg";